import React, { Component } from "react";
import { Wrapper, Copy, Bold, Button, Row } from "app/NativeComponents/common";
import { PopoverMenu } from "app/NativeComponents/snippets";
import ShowcaseFilters from "app/DealMachineCore/reuseable/AdvancedFilters/ShowcaseFilters";
class BranchComponent extends Component {
  render() {
    const {
      is_active,
      onPress,
      step,
      colors,
      workflow,
      active_step,
      step_index,
      branch_index = null,
      branch_step_index = null
    } = this.props;
    if (step) {
      return (
        <Button
          onPress={onPress}
          style={{
            borderColor: is_active ? colors.active_color : colors.border_color,
            backgroundColor: colors.card_color,
            borderWidth: 1,
            borderStyle: "solid",
            borderRadius: 5,
            margin: "auto",
            width: 350
          }}
        >
          <Wrapper>
            <Wrapper
              style={{
                padding: 15,
                borderBottomColor: is_active
                  ? colors.active_color
                  : colors.border_color,
                borderBottomWidth: 1,
                borderBottomStyle: "solid"
              }}
            >
              <Row>
                <Wrapper style={{ flex: 1 }}>
                  <Copy>
                    <Bold>If/then branch</Bold>
                  </Copy>
                </Wrapper>
                <PopoverMenu
                  icon={"more-vert"}
                  style={{ paddingLeft: 15 }}
                  icon_size={18}
                  menu_items={[
                    {
                      title: "Delete Component",
                      icon: "delete",
                      type: "delete",
                      onPress: () => {
                        this.props.setModal({
                          title: "Delete Component?",
                          description:
                            "Are you sure you want to delete this workflow component?",
                          submit: "Delete Component",
                          icon: "delete",
                          buttonType: "destroy",
                          onPress: () => {
                            this.props.deleteStep({
                              step_index,
                              branch_index,
                              branch_step_index
                            });
                          },
                          cancel: "",
                          onCancel: () => {}
                        });
                        this.props.toggleModal({
                          show: true,
                          type: "normal"
                        });
                      }
                    }
                  ]}
                />
              </Row>
            </Wrapper>
            <Wrapper>
              {is_active ? (
                <Wrapper style={{ padding: 20 }}>
                  <Copy
                    style={{
                      textAlign: "center",
                      color: colors.light_text_color
                    }}
                  >
                    Configuring...
                  </Copy>
                </Wrapper>
              ) : step.data && step.data.length > 0 ? (
                <Wrapper style={{ padding: 20 }}>
                  {step.data.map((branch, i) => {
                    if (!branch.else_branch) {
                      return (
                        <Wrapper key={"branch_" + i}>
                          <Wrapper style={{ padding: 0 }}>
                            {i == 0 ? (
                              <Copy style={{ fontSize: 12 }}>
                                First, check <Bold>{branch.branch_name}</Bold>
                              </Copy>
                            ) : (
                              <Copy style={{ fontSize: 12 }}>
                                Then, check <Bold>{branch.branch_name}</Bold>
                              </Copy>
                            )}
                          </Wrapper>
                          <ShowcaseFilters
                            {...this.props}
                            style={{ padding: 0 }}
                            filters={branch.filters?.data}
                            andor_type={branch.filters?.andor_type}
                            editable={false}
                          />
                        </Wrapper>
                      );
                    }
                    return null;
                  })}
                </Wrapper>
              ) : null}
            </Wrapper>
          </Wrapper>
        </Button>
      );
    }
    return null;
  }
}

export default BranchComponent;
